import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function useImportFiles(projectId, enabled) {
  return useQuery({
    queryKey: ["server-import-files", projectId],
    queryFn: async () => (await apiClient.get(`/projects/${projectId}/server-import/files`)).data,
    enabled: !!projectId && !!enabled,
  });
}

export function usePreviewFromDrive(projectId) {
  return useMutation({
    mutationFn: async (path) =>
      (await apiClient.post(`/projects/${projectId}/server-import/preview-drive`, { path })).data,
  });
}

export function usePreviewFromUpload(projectId) {
  return useMutation({
    mutationFn: async (file) => {
      const form = new FormData();
      form.append("file", file);
      return (await apiClient.post(`/projects/${projectId}/server-import/preview-upload`, form)).data;
    },
  });
}

export function useCommitImport(projectId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ sessionId, selections }) =>
      (await apiClient.post(`/projects/${projectId}/server-import/commit`, { session_id: sessionId, selections })).data,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["servers", projectId] });
    },
  });
}
